import $ from 'jquery';

const EVT = 'appliedFilters:change';

function makeKey({ type, name, value, id, label }) {
  if (id) return `${type}:${id}`;

  // fallback key: include name/value if present, otherwise label
  const n = name ?? '';
  const v = value ?? '';
  if (n || v) return `${type}:${n}:${v}`;

  // last-resort fallback
  return `${type}:label:${(label || '').trim()}`;
}


const store = (() => {
  let map = new Map();

  const emit = () => $(document).trigger(EVT, [getAll()]);

  const getAll = () => Array.from(map.values());

  const upsert = (filter) => {
    const key = makeKey(filter);
    map.set(key, { ...filter, key });
    emit();
  };

  const remove = (filterOrKey) => {
    const key = typeof filterOrKey === 'string' ? filterOrKey : makeKey(filterOrKey);
    map.delete(key);
    emit();
  };

  const clear = () => {
    map.clear();
    emit();
  };

  const has = (filterOrKey) => {
    const key = typeof filterOrKey === 'string' ? filterOrKey : makeKey(filterOrKey);
    return map.has(key);
  };

  return { getAll, upsert, remove, clear, has, EVT };
})();

export default store;



// WEBPACK FOOTER //
// ./src/scripts/modules/abtest/applied-filters-store.js